import { trpc } from "../trpc";
import { FolderTreeItem, updateFolderAttributeInTree } from "../folderTree";
import type { FolderTreeOutput } from "@zapier/bff";

interface useRenameFolderInput {
  id?: string;
}

export function useRenameFolder({ id }: useRenameFolderInput) {
  const utils = trpc.useUtils();

  const mutation = trpc.folder.rename.useMutation({
    // Callback to handle optimistic updates in RQ cache
    onMutate: ({ name }) => {
      if (!id) {
        return;
      }

      // Update Folder under folderTree key
      utils.folder.folderTree.cancel();
      utils.folder.folderTree.setData(
        {},
        (old: FolderTreeOutput | undefined) => {
          if (old?.hash[id]) {
            const updatedFolderTree = updateFolderAttributeInTree(
              old.tree,
              old?.hash[id] as FolderTreeItem,
              "name",
              name,
            );

            // this needs to return a new object ref for RQ to detect the change
            return {
              ...old,
              // update hash
              hash: {
                ...old.hash,
                [id]: {
                  ...old.hash[id],
                  name,
                },
              },
              // update tree
              tree: updatedFolderTree as FolderTreeItem[],
            };
          }

          return old;
        },
      );
    },
    // Callback to handle cache invalidation after mutation is completed
    onSettled: () => {
      utils.folder.folderTree.invalidate();
    },
  });

  return {
    rename: mutation.mutate,
    isLoading: mutation.isPending,
  };
}
